<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="app-main-inner-row">
        <div class="filters">
          <el-form :inline="true" label-width="60px" label-position="right">
            <div class="el-form-item-wrapper">
              <el-form-item :label="$t('SystemMaintenance.BusinessEntity')">
                <el-select v-model="searchConditions.entityCode">
                  <el-option
                    v-for="entity in entitySelectOption"
                    :key="entity.value"
                    :value="entity.value"
                    :label="entity.name"
                  />
                </el-select>
              </el-form-item>
              <el-form-item v-if="!isPlateForm" :label="$t('SystemMaintenance.Branch')">
                <el-select v-model="searchConditions.branchId">
                  <el-option
                    v-for="office in currentOfficeList"
                    :key="office.uuid"
                    :value="office.officeId"
                    :label="office.chineseName"
                  />
                </el-select>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="triggers">
          <el-button type="primary" @click="fetchDefaultValueList">{{ $t('common.btn.query') }}</el-button>
          <el-button type="primary" @click="toAdd">{{ $t('common.btn.new') }}</el-button>
          <el-button type="primary" @click="toEdit">{{ $t('common.btn.edit') }}</el-button>
          <el-button type="danger" @click="toBatchDel">{{ $t('common.btn.delete') }}</el-button>
          <el-button type="warning" @click="reset">{{ $t('common.btn.reset') }}</el-button>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="260304"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
    </div>
    <!-- 默认值管理新增窗口 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="addDialog.isShow"
      :close-on-click-modal="false"
      :title="$t('SystemMaintenance.SelectEntityConfigurationItem')"
      width="800px"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px">
        <div class="filters">
          <el-form label-width="80px" label-position="left">
            <div class="el-form-item-wrapper">
              <el-form-item :label="$t('SystemMaintenance.BranchOffice2')">
                <el-select v-model="addDialog.form.branchId" @change="changeAddDialogOffice">
                  <el-option
                    v-for="office in currentOfficeList"
                    :key="office.uuid"
                    :value="office.officeId"
                    :label="office.chineseName"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('SystemMaintenance.EntitySelection')">
                <div class="row-grid-dialog" style="width: 600px">
                  <cargo-ag-grid
                    :show-side-bar="false"
                    :grid-params.sync="addDialog.gridParams"
                    :grid-options="addDialog.gridOptions"
                    :column-defs="addDialogColumnDefs"
                    :row-data="addDialog.rowData"
                    style="width: 100%;"
                  />
                </div>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="saveAdd">{{ $t('common.btn.confirm') }}
        </el-button>
        <el-button @click="cancelSave">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!--  默认值管理编辑窗口  -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.isShow"
      :close-on-click-modal="false"
      width="400px"
    >
      <span slot="title" style="font-size: 18px">
        {{ $t('CargoMsg.Cargo_EditDefaultValue') }}
        <el-tooltip v-show="editDialog.form.entityCode === 'Job'" :content="$t('CargoMsg.Cargo_EditJobDefaultValueTip')" placement="top">
          <span style="border: 1px solid #AAAAAA;border-radius: 50%;padding: 0 3px;font-size: 12px;color: #AAAAAA;">?</span>
        </el-tooltip>
      </span>
      <div class="app-main-inner-row">
        <el-form :inline="true" label-width="80px" label-position="right">
          <div class="el-form-item-wrapper">
            <el-form-item v-model="editDialog.form" :label="$t('SystemMaintenance.AffiliatedBranchOffice')">
              <el-input v-model="editDialog.form.officeCnName" :disabled="true" />
            </el-form-item>
            <el-form-item v-model="editDialog.form" :label="$t('SystemMaintenance.EntityCode')">
              <el-input v-model="editDialog.form.entityCode" :disabled="canEdit" />
            </el-form-item>
            <el-form-item v-model="editDialog.form" :label="$t('SystemMaintenance.EntityName')">
              <el-input v-model="editDialog.form.entityName" :disabled="canEdit" />
            </el-form-item>
            <el-form-item v-model="editDialog.form" :label="$t('SystemMaintenance.FieldCode')">
              <el-input v-model="editDialog.form.fieldCode" :disabled="canEdit" />
            </el-form-item>
            <el-form-item v-model="editDialog.form" :label="$t('SystemMaintenance.FieldName')">
              <el-input v-model="editDialog.form.fieldName" :disabled="canEdit" />
            </el-form-item>
            <el-form-item v-model="editDialog.form" :label="$t('SystemMaintenance.ValueType')">
              <el-input v-model="editDialog.form.valueType" :disabled="canEdit" />
            </el-form-item>
            <el-form-item v-model="editDialog.form" :label="$t('CargoMsg.Cargo_DefaultValue')">
              <el-input v-model="editDialog.form.defaultValue" :type=" needTextareaField.includes(editDialog.form.fieldCode) ? 'textarea' : 'text'" />
            </el-form-item>
            <div v-show="editDialog.form.entityCode === 'Job'">
              <el-form-item v-model="editDialog.form" :label="$t('CargoMsg.Cargo_SeDefaultValue')">
                <el-input v-model="editDialog.form.seDefaultValue" />
              </el-form-item>
              <el-form-item v-model="editDialog.form" :label="$t('CargoMsg.Cargo_SiDefaultValue')">
                <el-input v-model="editDialog.form.siDefaultValue" />
              </el-form-item>
              <el-form-item v-model="editDialog.form" :label="$t('CargoMsg.Cargo_AeDfaultValue')">
                <el-input v-model="editDialog.form.aeDefaultValue" />
              </el-form-item>
              <el-form-item v-model="editDialog.form" :label="$t('CargoMsg.Cargo_AiDfaultValue')">
                <el-input v-model="editDialog.form.aiDefaultValue" />
              </el-form-item>
              <el-form-item v-model="editDialog.form" :label="$t('CargoMsg.Cargo_ReDfaultValue')">
                <el-input v-model="editDialog.form.reDefaultValue" />
              </el-form-item>
              <el-form-item v-model="editDialog.form" :label="$t('CargoMsg.Cargo_RiDfaultValue')">
                <el-input v-model="editDialog.form.riDefaultValue" />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="saveEdit">{{ $t('common.btn.confirm') }}
        </el-button>
        <el-button @click="cancelEdit">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { getUserInfo } from '@/utils/auth'
import { getGridSelected, getGridSelectedIds } from '@/utils/agGrid'
import {
  getEntityDefaultValue, addEntityDefaultValue, updateEntityDefaultValue,
  batchDelEntityDefaultValue, getDefaultValueEntity4List, getDefaultValueEntity4Add,
  addEntityDefaultValueForTenant, addEntityDefaultValueForPlateForm
} from '@/api/sysManage/baseConfig/defaultValueManage'

export default {
  name: 'DefaultManagement',
  data() {
    return {
      loading: false,
      tenantId: null,
      searchConditions: {
        branchId: '',
        entityCode: ''
      },
      entitySelectOption: [{
        name: this.$t('SystemMaintenance.All'),
        value: ''
      }],
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        }, {
          headerName: this.$t('SystemMaintenance.AffiliatedBranchOffice'),
          field: 'officeCnName'
        }, {
          headerName: this.$t('SystemMaintenance.EntityCode'),
          field: 'entityCode'
        }, {
          headerName: this.$t('SystemMaintenance.EntityName'),
          field: 'entityName',
          width: 150
        }, {
          headerName: this.$t('SystemMaintenance.FieldCode'),
          field: 'fieldCode'
        }, {
          headerName: this.$t('SystemMaintenance.FieldName'),
          field: 'fieldName'
        }, {
          headerName: this.$t('SystemMaintenance.ValueType'),
          field: 'valueType'
        }, {
          headerName: '默认值',
          field: 'defaultValue'
        }
      ],
      rowData: [],
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false
      },
      addDialog: {
        isShow: false,
        initForm: {
          branchId: ''
        },
        form: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false
        },
        rowData: []
      },
      editDialog: {
        isShow: false,
        form: {}
      },
      needTextareaField: ['AeHawbNotify', 'AeFhawbNotify', 'AeMawbNotify'],
      initForm: {
        uuid: '',
        version: 1,
        branchId: 0,
        userId: 0,
        entityCode: '',
        entityName: '',
        fieldCode: '',
        fieldName: '',
        valueType: '',
        defaultValue: '',
        seDefaultValue: '',
        siDefaultValue: '',
        aeDefaultValue: '',
        aiDefaultValue: '',
        reDefaultValue: '',
        riDefaultValue: ''
      }
    }
  },
  computed: {
    isPlateForm() { // 是否平台维护
      return this.tenantId <= 2
    },
    currentOfficeList() {
      return !this.isPlateForm ? getUserInfo().currentUserOfficeList : []
    },
    addDialogColumnDefs() {
      const list = [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('SystemMaintenance.EntityCode'),
          field: 'entityCode',
          width: 150
        },
        {
          headerName: this.$t('SystemMaintenance.EntityName'),
          field: 'entityName',
          width: 150
        }
      ]
      if (!this.isPlateForm) {
        list.push({
          headerName: this.$t('SystemMaintenance.FieldCode'),
          field: 'fieldCode',
          width: 150
        })
        list.push({
          headerName: this.$t('SystemMaintenance.FieldName'),
          field: 'fieldName',
          width: 150
        })
      }
      return list
    },
    canEdit() {
      return this.editDialog && this.editDialog.form && !!this.editDialog.form.uuid
    }
  },
  created() {
    this.tenantId = getUserInfo().tenantId
  },
  mounted() {
    getDefaultValueEntity4List().then(result => {
      result.data.forEach(item => {
        this.entitySelectOption.push({ name: item.entityName, value: item.entityCode })
      })
    })
    this.fetchDefaultValueList()
  },
  methods: {
    fetchDefaultValueList() {
      const self = this
      const params = { ...this.searchConditions }
      this.loading = getLoading()
      getEntityDefaultValue(params).then(result => {
        self.rowData = result.data
      }).finally(
        self.loading.close()
      )
    },
    toAdd() {
      if (this.isPlateForm) {
        this.editDialog.form = this.initForm
        this.editDialog.isShow = true
      } else {
        this.addDialog.form = { ...this.addDialog.initForm }
        this.addDialog.isShow = true
      }
    },
    toEdit() {
      const self = this
      getGridSelectedIds(this.gridOptions).then(ids => {
        if (ids.length !== 1) {
          self.$message.error(self.$t('common.tips.hasOneOnly'))
        } else {
          self.editDialog.form = { ...getGridSelected(this.gridOptions)[0] }
          self.editDialog.isShow = true
        }
      })
    },
    toBatchDel() {
      const self = this
      getGridSelectedIds(this.gridOptions, 'uuid').then(async ids => {
        if (ids.length < 1) {
          self.$message.error(self.$t('common.tips.hasOneOnly'))
        } else {
          await self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.confirm'), { type: 'warning' })
          self.loading = getLoading()
          batchDelEntityDefaultValue(ids).then(() => {
            self.fetchDefaultValueList()
            self.$message.success(self.$t('common.tips.deleteSuccess'))
          }).finally(() => {
            self.loading.close()
          })
        }
      })
    },
    reset() {
      this.searchConditions.branchId = ''
      this.searchConditions.entityCode = ''
    },
    changeAddDialogOffice(value) {
      const self = this
      this.loading = getLoading()
      getDefaultValueEntity4Add(value).then((result) => {
        self.addDialog.rowData = result.data
      }).finally(() => {
        self.loading.close()
      })
    },
    cancelSave() {
      this.addDialog.rowData = []
      this.addDialog.isShow = false
    },
    saveAdd() {
      const self = this
      if (this.isPlateForm) { // 平台维护
        getGridSelectedIds(this.addDialog.gridOptions, 'entityCode').then(async codes => {
          if (codes.length < 1) {
            self.$message.error(self.$t('common.tips.hasOneAtleast'))
          } else {
            this.loading = getLoading()
            addEntityDefaultValue(this.addDialog.form.branchId, [...codes]).then(() => {
              self.fetchDefaultValueList()
              this.cancelSave()
              self.$message.success(self.$t('common.tips.saveSuccess'))
            }).finally(() => {
              self.loading.close()
            })
          }
        })
      } else { // 租户
        getGridSelectedIds(this.addDialog.gridOptions, 'uuid').then(async codes => {
          if (codes.length < 1) {
            self.$message.error(self.$t('common.tips.hasOneAtleast'))
          } else {
            this.loading = getLoading()
            addEntityDefaultValueForTenant(this.addDialog.form.branchId, [...codes]).then(() => {
              self.fetchDefaultValueList()
              this.cancelSave()
              self.$message.success(self.$t('common.tips.saveSuccess'))
            }).finally(() => {
              self.loading.close()
            })
          }
        })
      }
    },
    cancelEdit() {
      this.editDialog.isShow = false
    },
    saveEdit() {
      if (!this.isPlateForm || (this.isPlateForm && this.editDialog.form && this.editDialog.form.uuid)) {
        const self = this
        this.loading = getLoading()
        updateEntityDefaultValue(this.editDialog.form).then(() => {
          this.editDialog.isShow = false
          self.fetchDefaultValueList()
          self.$message.success(self.$t('common.tips.editSuccess'))
        }).finally(() => {
          self.loading.close()
        })
      } else {
        this.loading = getLoading()
        addEntityDefaultValueForPlateForm(this.editDialog.form).then(() => {
          this.editDialog.isShow = false
          this.fetchDefaultValueList()
          this.$message.success(this.$t('CargoMsg.Cargo_AddedSuccessfully'))
        }).finally(() => {
          this.loading.close()
        })
      }
    }
  }
}
</script>
